export default __webpack_public_path__ + "static/media/clouds-smm.b5f3e703.png";